module.exports = __webpack_public_path__ + "static/media/SupportIcon.6ad5c8d1.svg";